import { Const } from "const";
import { Utils } from "helpers/utils";

interface UserAvatarProps {
    profileImage: string,
    bgColor?: string,
    foreColor?: string,
    abbrName?: string,
    size?: string,
    includeDivContainer?: boolean,
    userId?: number | null,
    classMe?: string | null,
}
const UserAvatar = ({ profileImage, bgColor, foreColor, abbrName, size, includeDivContainer = true, userId = null, classMe = "me-2" }: UserAvatarProps) => {
    const cssFore = foreColor?.replace("#", "avatar-fore-");
    const cssSize = "avatar-" + (size ? size : "xs");
    const imgSize = "img-" + (size ? size : "xs");
    // console.log('abbr = ' + abbrName + ', fore = ' + foreColor);
    const profileImage2 = (userId == -1 || userId == -2) ? Const.IMG_AVATA_CHATBOT : Utils.FixResourceUrlForNative(profileImage);
    const avatarIcon = (
        <>
            {profileImage2 && (
                <img data-uid={userId} src={profileImage2} onError={(e) => { (e.currentTarget as HTMLImageElement).src = '/icons/user-dummy-img.jpg'; }} alt="bbc" className={"img-fluid rounded-circle img-fit " + imgSize}></img>
            )}
            {!profileImage2 && (
                <span data-uid={userId} className={"avatar-title rounded-circle text-uppercase " + cssFore} style={{ backgroundColor: bgColor, color: foreColor }}>{abbrName}</span>
            )}
        </>
    );

    return includeDivContainer ? (
        <div className={"flex-shrink-0 " + cssSize + " " + classMe} >{avatarIcon}</div>
    ) : (
        avatarIcon
    );


    // return (
    //     <div className={"flex-shrink-0 " + cssSize + " me-2"} >
    //         {profileImage && (
    //             <img src={profileImage} onError={(e) => { (e.currentTarget as HTMLImageElement).src = '/icons/user-dummy-img.jpg'; }} alt="" className="img-fluid rounded-circle"></img>
    //         )}
    //         {!profileImage && (
    //             <span className={"avatar-title rounded-circle text-uppercase " + cssFore} style={{ backgroundColor: bgColor, color: foreColor }}>{abbrName}</span>
    //         )}
    //     </div>
    // );
}
export default UserAvatar;